import { CarrierPaymentTypeEnum, CarriersEnum, CarrierStatusEnum, SnackBarVariants, StatusEnum } from '@app/app.enum';
import { IHistoryState } from '@app/app.routes';
import { withAxiosCancellation } from '@app/components/core/axios-cancel.component';
import withSnackBar from '@app/components/core/message.component';
import CustomDialogBox from '@app/components/shared/dialog.component';
import Icon from '@app/components/shared/icon.component';
import NoDataComponent from '@app/components/shared/no-data.component';
import { CustomsItemMaxDeclaredValueLimit } from '@app/constants';
import * as models from '@app/models';
import { ISnackBarFeature } from '@app/models';
import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';
import { AdminCarrierService } from '@app/services/admin-carrier.service';
import { IntlService } from '@app/services/intl.service';
import { SharedService } from '@app/services/shared.service';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Button,
	Card,
	CardContent,
	Divider,
	FormControlLabel,
	Grid,
	GridList,
	GridListTile,
	Link,
	List,
	ListItem,
	ListItemAvatar,
	ListItemSecondaryAction,
	ListItemText,
	MenuItem,
	Radio,
	RadioGroup,
	Switch,
	Tab,
	Tabs,
	TextField,
	Typography,
} from '@material-ui/core';
import Axios from 'axios';
import classNames from 'classnames';
import { Field, Form, Formik, FormikProps, FormikValues } from 'formik';
import * as queryString from 'querystring';
import React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as Yup from 'yup';
import FedExNativeTrackngRangeImportAccordion from './fedex-native-tracking-range-import-accordion';

const intlService: IntlService = Injector.get(IntlService);
const accountService: AccountService = Injector.get(AccountService);
const sharedService: SharedService = Injector.get(SharedService);
const adminCarrierService: AdminCarrierService = Injector.get(AdminCarrierService);
const customsItemMinValue = 0;

const TabPanel = (props: any) => {
	const { children, value, index } = props;

	return (
		<div role='tabpanel' hidden={value !== index}>
			{value === index && <Box>{children}</Box>}
		</div>
	);
};

interface ICarrierAdminDetailsComponentProps
	extends ISnackBarFeature,
		RouteComponentProps<any, any, IHistoryState>,
		InjectedIntlProps {}

interface ICarrierAdminDetailsComponentStates {
	carrier: models.ICarrier;
	tab: 0 | 1 | 2 | 3;
	services: models.IService[];
	packageTypes: models.IPackageType[];
	specialServices: models.ISpecialService[];
	carrierEnabled: CarrierStatusEnum;
	openDialog: boolean;
	dialogTitle: string;
	dialogDescription: string;
	buttonLoading: boolean;
	buttonDisabled: boolean;
	paymentType: CarrierPaymentTypeEnum;
	isOpenCarrierConfigDialog: boolean;
	customsItemMaxDeclaredValue: number;
	fedexNativeLastRangeDate: Date;
}

const defaultCarrier: models.ICarrier = {
	id: '',
	code: null,
	name: '',
	logo: '',
	scac: null,
	description: '',
	paymentType: null,
	provider: null,
	status: null,
};

class CarrierAdminDetailsComponent extends React.Component<
	ICarrierAdminDetailsComponentProps,
	ICarrierAdminDetailsComponentStates
> {
	private serviceID: string;
	private serviceStatus: StatusEnum;
	private packageTypeID: string;
	private packageTypeStatus: StatusEnum;
	private specialServiceID: string;
	private specialServiceStatus: StatusEnum;
	private customsItemMaxDeclaredValueSchema: any = Yup.object().shape<{
		customsItemMaxDeclaredValue: number;
	}>({
		customsItemMaxDeclaredValue: Yup.number()
			.min(
				CustomsItemMaxDeclaredValueLimit[0],
				intlService.GetFormattedMessage('app.carrier-details.max-value-validation', {
					['0']: CustomsItemMaxDeclaredValueLimit[1],
				})
			)
			.max(
				CustomsItemMaxDeclaredValueLimit[1],
				intlService.GetFormattedMessage('app.carrier-details.max-value-validation', {
					['0']: CustomsItemMaxDeclaredValueLimit[1],
				})
			)
			.nullable(),
	});

	constructor(props: any) {
		super(props);

		this.state = {
			carrier: defaultCarrier,
			carrierEnabled: null,
			tab: this.props.history.location.state?.tab ?? 0,
			services: [],
			packageTypes: [],
			specialServices: [],
			openDialog: false,
			buttonLoading: false,
			buttonDisabled: false,
			dialogTitle: '',
			dialogDescription: '',
			isOpenCarrierConfigDialog: false,
			paymentType: null,
			customsItemMaxDeclaredValue: null,
			fedexNativeLastRangeDate: null,
		};
	}

	public componentDidMount() {
		const carrierId = this.props.location.state.carrierId;
		this.getCarrierServices(carrierId);
		this.getCarrierPackageTypes(carrierId);
		this.getCarrierSpecialServices(carrierId);
		this.fetchCarrier(carrierId);
		this.getFedExNativeLastImportedTrackingRangeDate();
	}

	public render() {
		return (
			<>
				{/* // Dialog Component */}
				<CustomDialogBox
					open={this.state.openDialog}
					submitButton={{
						isLoading: this.state.buttonLoading,
						isDisabled: this.state.buttonDisabled,
						isSubmit: false,
						onSubmit: null,
					}}
					dialogTitle={this.state.dialogTitle}
					dialogId={this.state.dialogTitle}
					dialogDescription={this.state.dialogDescription}
					dialogNoButton={intlService.GetFormattedMessage('app.billing.auto-buy-confirm-dialog-cancel-button-text')}
					dialogYesButton={intlService.GetFormattedMessage('app.billing.auto-buy-confirm-dialog-confirm-button-text')}
					closeCustomDialog={this.closeDialog}
				/>
				<Card>
					<CardContent>
						<List>
							<ListItem ContainerComponent='div' className='pt-0 pb-0'>
								<ListItemAvatar classes={{ root: 'pr-2' }}>
									<GridList cols={1} cellHeight={140} className='selected-carrier-list-tile'>
										<GridListTile
											classes={{
												root: 'gridListTitle-root',
											}}
										>
											<div className='carriers-tile'>
												<img
													key={this.state.carrier.name}
													src={this.state.carrier.logo}
													className='carrier-img-detail'
												/>
											</div>
										</GridListTile>
									</GridList>
								</ListItemAvatar>
								<ListItemText>
									<Grid container={true}>
										<Grid item={true} xs={3} sm={3} md={3} lg={3} xl={3}>
											<Typography noWrap={true} color='inherit' variant='body2'>
												<strong>{`${intlService.GetFormattedMessage('app.carrier-name-label')}:`}</strong>
											</Typography>
										</Grid>
										<Grid item={true} xs={7} sm={7} md={7} lg={7} xl={7}>
											<Typography variant='body2' noWrap={true}>
												{this.state.carrier.name}
											</Typography>
										</Grid>
										<Grid item={true} xs={3} sm={3} md={3} lg={3} xl={3}>
											<Typography noWrap={true} color='inherit' variant='body2'>
												<strong>{`${intlService.GetFormattedMessage('app.carrier-scac-label')}:`}</strong>
											</Typography>
										</Grid>
										<Grid item={true} xs={7} sm={7} md={7} lg={7} xl={7}>
											<Typography noWrap={true} variant='body2'>
												{this.state.carrier.scac}
											</Typography>
										</Grid>
										<Grid item={true} xs={3} sm={3} md={3} lg={3} xl={3}>
											<Typography noWrap={true} color='inherit' variant='body2'>
												<strong>{`${intlService.GetFormattedMessage('app.carrier-id-label')}: `}</strong>
											</Typography>
										</Grid>
										<Grid item={true} xs={7} sm={7} md={7} lg={7} xl={7}>
											<Typography noWrap={true} variant='body2'>
												{this.state.carrier.code}
											</Typography>
										</Grid>
										<Grid item={true} xs={3} sm={3} md={3} lg={3} xl={3}>
											<Typography noWrap={true} color='inherit' variant='body2'>
												<strong>{`${intlService.GetFormattedMessage('app.carrier-description-label')}: `}</strong>
											</Typography>
										</Grid>
										<Grid item={true} xs={7} sm={7} md={7} lg={7} xl={7}>
											<Typography variant='body2'>{this.state.carrier.description}</Typography>
										</Grid>
										<Grid item={true} xs={3} sm={3} md={3} lg={3} xl={3}>
											<Typography noWrap={true} color='inherit' variant='body2'>
												<strong>{`${intlService.GetFormattedMessage('app.carrier-provider-label')}: `}</strong>
											</Typography>
										</Grid>
										<Grid item={true} xs={7} sm={7} md={7} lg={7} xl={7}>
											<Typography noWrap={true} variant='body2'>
												{this.state.carrier.provider}
											</Typography>
										</Grid>
										<Grid item={true} xs={3} sm={3} md={3} lg={3} xl={3}>
											<Typography noWrap={true} color='inherit' variant='body2'>
												<strong>{`${intlService.GetFormattedMessage('app.carrier-payment-type-label')}: `}</strong>
											</Typography>
										</Grid>
										<Grid item={true} xs={7} sm={7} md={7} lg={7} xl={7}>
											<Typography noWrap={true} variant='body2'>
												{this.state.carrier.paymentType}
											</Typography>
										</Grid>
									</Grid>
								</ListItemText>
								<ListItemSecondaryAction>
									<Typography variant='body2' align='left'>
										<strong>{`${intlService.GetFormattedMessage('app.carrier-status-label')}: `}</strong>
										{this.state.carrierEnabled}
									</Typography>

									<RadioGroup
										value={this.state.carrierEnabled}
										onChange={(e: React.ChangeEvent, value: string) => {
											this.setState({
												carrierEnabled: value as CarrierStatusEnum,
												openDialog: true,
											});

											this.configCustomDialog(
												intlService.GetFormattedMessage('app.carrier-label'),
												intlService.GetFormattedMessage('app.carrier.status-confirm-dialog-text', { status: value })
											);
										}}
									>
										<FormControlLabel
											value={CarrierStatusEnum.Public}
											control={<Radio />}
											label={CarrierStatusEnum.Public}
										/>
										<FormControlLabel
											value={CarrierStatusEnum.Private}
											control={<Radio />}
											label={CarrierStatusEnum.Private}
										/>
										<FormControlLabel
											value={CarrierStatusEnum.Disabled}
											control={<Radio />}
											label={CarrierStatusEnum.Disabled}
										/>
									</RadioGroup>
								</ListItemSecondaryAction>
							</ListItem>
						</List>
						<Tabs
							value={this.state.tab}
							indicatorColor='secondary'
							textColor='secondary'
							variant='fullWidth'
							className='mt-1'
							onChange={(e: React.ChangeEvent, newValue: any) => this.setState({ tab: newValue })}
						>
							<Tab label={intlService.GetFormattedMessage('app.carrier-services-label')} />
							<Tab label={intlService.GetFormattedMessage('app.carrier-package-types-label')} />
							<Tab label={intlService.GetFormattedMessage('app.carrier-special-services-label')} />
							<Tab label={intlService.GetFormattedMessage('app.carrier-configuration-label')} />
						</Tabs>
						{/* Service tab */}
						<TabPanel value={this.state.tab} index={0}>
							<List>
								{this.state.services.length === 0 ? (
									<NoDataComponent />
								) : (
									this.state.services.map((service: models.IService) => this.getCarrierServicesList(service))
								)}
							</List>
						</TabPanel>
						{/* Package type tab */}
						<TabPanel value={this.state.tab} index={1}>
							<List>
								{this.state.packageTypes.length === 0 ? (
									<NoDataComponent />
								) : (
									this.state.packageTypes.map((packageType: models.IPackageType) =>
										this.getCarrierPackageTypesList(packageType)
									)
								)}
							</List>
						</TabPanel>
						{/* Special service tab */}
						<TabPanel value={this.state.tab} index={2}>
							<List>
								{this.state.specialServices.length === 0 ? (
									<NoDataComponent />
								) : (
									this.state.specialServices.map((specialService: models.ISpecialService) =>
										this.getCarrierSpecialServicesList(specialService)
									)
								)}
							</List>
						</TabPanel>
						{/* Configuration tab */}
						<TabPanel value={this.state.tab} index={3}>
							<List className='mt-2'>
								<Grid container={true} className='mt-2' direction='column' spacing={2}>
									{/* Billing configs accordion */}
									<Grid item={true} xs={12}>
										<Accordion defaultExpanded={true}>
											<AccordionSummary expandIcon={<Icon name='chevron-down' />}>
												<Grid container={true} direction='row' justifyContent='space-evenly'>
													<Grid item={true} xs={12}>
														<Typography variant='h6' color='inherit'>
															{intlService.GetFormattedMessage(
																'app.admin.carrier-configuration-accordion-Payment-and-Declared-Value-label'
															)}
														</Typography>
													</Grid>
												</Grid>
											</AccordionSummary>

											<AccordionDetails>
												<Grid container={true}>
													<Grid item={true} lg={12} md={12} sm={12} xs={12}>
														<Grid
															container={true}
															direction='row'
															justifyContent='space-evenly'
															alignItems='center'
															spacing={2}
														>
															<Grid item={true} xs={12} md={2} lg={4}>
																<Typography variant='subtitle2' color='inherit' className='pl-2'>
																	{intlService.GetFormattedMessage('app.carrier-payment-type-label')}
																</Typography>
															</Grid>
															<Grid item={true} xs={12} md={10} lg={8}>
																<TextField
																	variant='outlined'
																	size='small'
																	select={true}
																	fullWidth={true}
																	value={this.state.paymentType}
																	onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
																		this.setState({
																			paymentType: e.target.value as CarrierPaymentTypeEnum,
																		})
																	}
																	SelectProps={{
																		renderValue: (value: string) =>
																			`${value} - ${intlService.GetFormattedMessage(`carrier.${value}.description`)}`,
																		MenuProps: {
																			PaperProps: {
																				style: {
																					maxHeight: '250px',
																				},
																			},
																		},
																	}}
																>
																	{Object.entries(CarrierPaymentTypeEnum).map(
																		([key, value]: [string, string], index: number) => (
																			<MenuItem key={index} value={value}>
																				{key} - {intlService.GetFormattedMessage(`carrier.${key}.description`)}
																			</MenuItem>
																		)
																	)}
																</TextField>
															</Grid>

															<Grid item={true} xs={12} md={2} lg={4}>
																<Typography variant='subtitle2' color='inherit' className='pl-2'>
																	{intlService.GetFormattedMessage(
																		'app.admin.carrier-details-list-customsItem-value-configuration-label'
																	)}
																</Typography>
															</Grid>
															<Grid item={true} xs={12} md={10} lg={8}>
																<Formik
																	initialValues={{
																		customsItemMaxDeclaredValue: this.state.customsItemMaxDeclaredValue,
																	}}
																	enableReinitialize={true}
																	validationSchema={this.customsItemMaxDeclaredValueSchema}
																	onSubmit={() =>
																		this.setState({
																			isOpenCarrierConfigDialog: true,
																		})
																	}
																	render={(props: FormikProps<FormikValues>) => (
																		<Form noValidate={true}>
																			<Field
																				name='customsItemMaxDeclaredValue'
																				type='number'
																				variant='outlined'
																				size='small'
																				component={TextField}
																				required={true}
																				fullWidth={true}
																				value={this.state.customsItemMaxDeclaredValue}
																				onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
																					props.handleChange('customsItemMaxDeclaredValue')(e);
																					this.setState({
																						customsItemMaxDeclaredValue: e.target.value as any,
																					});
																				}}
																				error={!!props.errors.customsItemMaxDeclaredValue}
																				helperText={props.errors.customsItemMaxDeclaredValue}
																				InputProps={{
																					inputProps: {
																						min: customsItemMinValue,
																					},
																				}}
																			/>
																		</Form>
																	)}
																/>
															</Grid>

															<Grid item={true} xs={12}>
																<CustomDialogBox
																	open={this.state.isOpenCarrierConfigDialog}
																	submitButton={{
																		isSubmit: false,
																		isLoading: this.state.buttonLoading,
																		isDisabled: this.state.buttonLoading,
																		onSubmit: null,
																	}}
																	dialogTitle={intlService.GetFormattedMessage(
																		'app.carrier-details.update-config-dialog-title'
																	)}
																	dialogId={intlService.GetFormattedMessage(
																		'app.carrier-details.update-config-dialog-title'
																	)}
																	dialogDescription={intlService.GetFormattedMessage(
																		'app.carrier-details.dialog-description'
																	)}
																	dialogNoButton={intlService.GetFormattedMessage(
																		'app.billing.auto-buy-confirm-dialog-cancel-button-text'
																	)}
																	dialogYesButton={intlService.GetFormattedMessage(
																		'app.billing.auto-buy-confirm-dialog-confirm-button-text'
																	)}
																	closeCustomDialog={(dialogPanel?: string, isCancel?: boolean) => {
																		if (!isCancel) {
																			this.updateCarrierConfiguration(this.props.location.state.carrierId, {
																				paymentType: this.state.paymentType,
																				customsItemMaxDeclaredValue: this.state.customsItemMaxDeclaredValue,
																			});
																			return;
																		}
																		this.setState((prevState) => ({
																			isOpenCarrierConfigDialog: false,
																			paymentType: prevState.carrier.paymentType,
																			customsItemMaxDeclaredValue: prevState.carrier.customsItemMaxDeclaredValue,
																		}));
																	}}
																/>
															</Grid>
														</Grid>

														<Grid
															container={true}
															direction='row'
															justifyContent='space-evenly'
															alignItems='center'
															spacing={2}
														>
															<Grid item={true} className='buttons'>
																<Button
																	color='secondary'
																	onClick={() =>
																		this.setState({
																			isOpenCarrierConfigDialog: true,
																		})
																	}
																	disabled={
																		this.state.customsItemMaxDeclaredValue < CustomsItemMaxDeclaredValueLimit[0] ||
																		this.state.customsItemMaxDeclaredValue > CustomsItemMaxDeclaredValueLimit[1]
																	}
																>
																	{intlService.GetFormattedMessage('app.user.save-button')}
																</Button>
															</Grid>
														</Grid>
													</Grid>
												</Grid>
											</AccordionDetails>
										</Accordion>
									</Grid>
									{/* Tracking range accordion for fedex-native */}
									<Grid item={true} xs={12} className='tracking-range-accordion'>
										{/* Tracking Range Accodion */}
										{this.state.carrier.code !== null && this.state.carrier.code === CarriersEnum.FedExNative && (
											<FedExNativeTrackngRangeImportAccordion
												fedexNativeLastRangeDate={this.state.fedexNativeLastRangeDate}
												importTrackingRange={this.importTrackingRange}
											/>
										)}
									</Grid>
								</Grid>
							</List>
						</TabPanel>
					</CardContent>
				</Card>
			</>
		);
	}

	public downloadTrackingRange = async () => {
		try {
			const updateRequest: models.IFedExNativeUpsertSequenceNumber = {
				accountNumber: null,
				meterNumber: null,
				sequenceNumber: null,
				sequenceNumberStart: null,
				sequenceNumberEnd: null,
				smartPostMailerId: null,
			};

			const importedTrackingRangeForCarriers = await accountService.UpdateFedExSequenceNumber(updateRequest);

			this.props.openSnackBar(
				intlService.GetFormattedMessage(`app.snackbar.tracking-range-import-for-carrier-account`, {
					0: importedTrackingRangeForCarriers,
				})
			);
		} catch (err) {
			this.props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
		}
	};

	public getFedExNativeLastImportedTrackingRangeDate = async () => {
		try {
			const lastImportedDate = await adminCarrierService.GetFedexNativeLastImportedTrackingRangeDate();
			this.setState({
				fedexNativeLastRangeDate:
					lastImportedDate.lastImportedDate === undefined ? null : lastImportedDate.lastImportedDate,
			});
		} catch (error) {
			if (!Axios.isCancel(error)) {
				throw error;
			}
		}
	};

	public importTrackingRange = async () => {
		await this.downloadTrackingRange();
		await this.getFedExNativeLastImportedTrackingRangeDate();
	};

	public closeDialog = async (dialogPanel?: string, isCancel?: boolean) => {
		try {
			// If Confirm button of dialog is clicked then make an API call
			if (!isCancel) {
				this.setState({
					buttonDisabled: true,
					buttonLoading: true,
				});

				switch (dialogPanel) {
					case intlService.GetFormattedMessage('app.service-label'):
						await this.updateServiceStatus();
						break;
					case intlService.GetFormattedMessage('app.carrier-label'):
						await this.updateCarrierStatus();
						break;
					case intlService.GetFormattedMessage('app.package-type-label'):
						await this.updatePackageTypeStatus();
						break;
					case intlService.GetFormattedMessage('app.special-service-label'):
						await this.updateSpecialServiceStatus();
					default:
						break;
				}

				this.setState({
					buttonDisabled: false,
					buttonLoading: false,
				});
			}
			// else update the carrier enable state to original one
			else {
				switch (dialogPanel) {
					case intlService.GetFormattedMessage('app.carrier-label'):
						this.setState((prevState: ICarrierAdminDetailsComponentStates) => ({
							carrierEnabled: prevState.carrier.status,
						}));
						break;
					case intlService.GetFormattedMessage('app.service-label'):
					case intlService.GetFormattedMessage('app.package-type-label'):
					case intlService.GetFormattedMessage('app.special-service-label'):
					default:
						break;
				}
			}
			this.setState({ openDialog: false });
		} catch (err) {
			this.setState({
				buttonDisabled: false,
				buttonLoading: false,
			});
			if (!Axios.isCancel(err)) {
				this.openSnackbar(sharedService.parseError(err.data), SnackBarVariants.Error);
			}
		}
	};

	// set custom dialog configurations
	public configCustomDialog = (dialogTitle: string, dialogDescription: string) => {
		this.setState({
			openDialog: true,
			dialogTitle,
			dialogDescription,
		});
	};

	// open  snackbar
	public openSnackbar = (message: string | string[], variantName: SnackBarVariants = SnackBarVariants.Success) => {
		this.setState({
			openDialog: false,
		});
		this.props.openSnackBar(message, variantName);
	};

	// Fetch services for the carrier
	public getCarrierServices = async (carrierId: string) => {
		try {
			const services = await adminCarrierService.getCarrierServices(carrierId);
			this.setState({
				services,
			});
		} catch (error) {
			if (!Axios.isCancel(error)) {
				throw error;
			}
		}
	};

	// Fetch package types  for the carrier
	public getCarrierPackageTypes = async (carrierId: string) => {
		try {
			const packageTypes = await adminCarrierService.getCarrierPackageTypes(carrierId);
			this.setState({
				packageTypes,
			});
		} catch (error) {
			if (!Axios.isCancel(error)) {
				throw error;
			}
		}
	};

	// Fetch special services for the carrier
	public getCarrierSpecialServices = async (carrierId: string) => {
		try {
			const specialServices = await adminCarrierService.getCarrierSpecialServices(carrierId);
			this.setState({
				specialServices,
			});
		} catch (error) {
			if (!Axios.isCancel(error)) {
				throw error;
			}
		}
	};

	// Fetch a carrier
	public fetchCarrier = async (carrierId: string) => {
		try {
			const carrier = await adminCarrierService.getCarrier(carrierId);
			this.setState({
				carrier,
				paymentType: carrier.paymentType,
				carrierEnabled: carrier.status,
				customsItemMaxDeclaredValue: carrier.customsItemMaxDeclaredValue,
			});
		} catch (error) {
			if (!Axios.isCancel(error)) {
				throw error;
			}
		}
	};

	// Update carrier configuration
	public updateCarrierConfiguration = async (carrierId: string, configs: models.ICarrierConfiguration) => {
		try {
			this.setState({
				buttonLoading: true,
				buttonDisabled: true,
			});

			await adminCarrierService.updateCarrierConfiguration(carrierId, configs);

			this.openSnackbar(intlService.GetFormattedMessage('app.carrier-card.configuration-update-successful'));
			this.setState((prevState) => ({
				carrier: {
					...prevState.carrier,
					paymentType: prevState.paymentType,
					customsItemMaxDeclaredValue: prevState.customsItemMaxDeclaredValue,
				},
				isOpenCarrierConfigDialog: false,
				buttonLoading: false,
				buttonDisabled: false,
			}));
		} catch (error) {
			this.setState({
				buttonLoading: false,
				buttonDisabled: false,
			});
			if (!Axios.isCancel(error)) {
				this.openSnackbar(sharedService.parseError(error.data), SnackBarVariants.Error);
			}
		}
	};

	// Return carrier package types or special services based on input
	public getCarrierSpecialServicesList = (specialService: models.ISpecialService) => {
		return (
			<React.Fragment key={specialService.id}>
				<Divider />
				<ListItem ContainerComponent='div'>
					<ListItemText>
						<Grid container={true}>
							<Grid item={true} xs={8} sm={8} md={8} lg={8} xl={8}>
								<Grid container={true}>
									<Grid item={true} xs={6} sm={3} md={3} lg={3} xl={3}>
										<Typography noWrap={true} color='inherit' variant='body2'>
											<strong>{`${intlService.GetFormattedMessage('app.special-service-code-label')}:`}</strong>
										</Typography>
									</Grid>
									<Grid item={true} xs={6} sm={9} md={9} lg={9} xl={9}>
										<Typography variant='body2' noWrap={true}>
											{specialService.code}
										</Typography>
									</Grid>
								</Grid>
								<Grid container={true}>
									<Grid item={true} xs={6} sm={3} md={3} lg={3} xl={3}>
										<Typography noWrap={true} color='inherit' variant='body2'>
											<strong>{`${intlService.GetFormattedMessage('app.special-service-name-label')}:`}</strong>
										</Typography>
									</Grid>
									<Grid item={true} xs={6} sm={9} md={9} lg={9} xl={9}>
										<Typography noWrap={true} variant='body2'>
											{specialService.name}
										</Typography>
									</Grid>
								</Grid>
							</Grid>
							<Grid item={true} xs={2} sm={2} md={2} lg={2} xl={2} style={{ alignSelf: 'center' }}>
								<Link
									variant='body2'
									align='right'
									component='button'
									disabled={specialService.status === StatusEnum.Disabled}
									className={classNames({ 'disabled-link': specialService.status === StatusEnum.Disabled })}
									onClick={() => {
										const query = queryString.stringify({
											carrierCode: this.state.carrier.code,
											serviceCode: specialService.code,
										});

										const stateBreadcrumb = Array.isArray(this.props.history.location.state.breadcrumb)
											? this.props.history.location.state.breadcrumb
											: [this.props.history.location.state.breadcrumb];

										const breadcrumb = [
											...stateBreadcrumb,
											{ title: specialService.code, location: this.props.history.location },
										];

										this.props.history.push({
											pathname: this.props.match.url + '/specialService',
											search: query,
											state: {
												breadcrumb,
											},
										});
									}}
								>
									<FormattedMessage id='app.component.account-level-overrides' />
								</Link>
							</Grid>
							<Grid item={true} xs={2} sm={2} md={2} lg={2} xl={2}>
								<Typography variant='body2' align='right'>
									<Switch
										onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
											this.configCustomDialog(
												intlService.GetFormattedMessage('app.special-service-label'),
												intlService.GetFormattedMessage(
													e.target.checked
														? 'app.common.enable-confirm-dialog-text'
														: 'app.common.disable-confirm-dialog-text',
													{
														name: intlService.GetFormattedMessage('app.special-service-label'),
													}
												)
											);

											this.specialServiceID = specialService.id;
											this.specialServiceStatus = e.target.checked ? StatusEnum.Public : StatusEnum.Disabled;
										}}
										color='primary'
										disabled={false}
										checked={specialService.status === StatusEnum.Public ? true : false}
									/>
								</Typography>
							</Grid>
						</Grid>
					</ListItemText>
				</ListItem>
			</React.Fragment>
		);
	};

	// Return carrier package types or special services based on input
	private getCarrierPackageTypesList = (packageType: models.IPackageType) => {
		return (
			<React.Fragment key={packageType.id}>
				<Divider />
				<ListItem ContainerComponent='div'>
					<ListItemText>
						<Grid container={true}>
							<Grid item={true} xs={10} sm={10} md={10} lg={10} xl={10}>
								<Grid container={true}>
									<Grid item={true} xs={6} sm={3} md={3} lg={3} xl={3}>
										<Typography noWrap={true} color='inherit' variant='body2'>
											<strong>{`${intlService.GetFormattedMessage('app.package-type-code-label')}:`}</strong>
										</Typography>
									</Grid>
									<Grid item={true} xs={6} sm={7} md={7} lg={7} xl={7}>
										<Typography variant='body2' noWrap={true}>
											{packageType.code}
										</Typography>
									</Grid>
								</Grid>
								<Grid container={true}>
									<Grid item={true} xs={6} sm={3} md={3} lg={3} xl={3}>
										<Typography noWrap={true} color='inherit' variant='body2'>
											<strong>{`${intlService.GetFormattedMessage('app.package-type-name-label')}:`}</strong>
										</Typography>
									</Grid>
									<Grid item={true} xs={6} sm={9} md={9} lg={9} xl={9}>
										<Typography noWrap={true} variant='body2'>
											{packageType.name}
										</Typography>
									</Grid>
								</Grid>
							</Grid>
							<Grid item={true} xs={2} sm={2} md={2} lg={2} xl={2}>
								<Typography variant='body2' align='right'>
									<Switch
										onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
											this.configCustomDialog(
												intlService.GetFormattedMessage('app.package-type-label'),
												intlService.GetFormattedMessage(
													e.target.checked
														? 'app.common.enable-confirm-dialog-text'
														: 'app.common.disable-confirm-dialog-text',
													{
														name: intlService.GetFormattedMessage('app.package-type-label'),
													}
												)
											);

											this.packageTypeID = packageType.id;
											this.packageTypeStatus = e.target.checked ? StatusEnum.Public : StatusEnum.Disabled;
										}}
										color='primary'
										disabled={false}
										checked={packageType.status === StatusEnum.Public ? true : false}
									/>
								</Typography>
							</Grid>
						</Grid>
					</ListItemText>
				</ListItem>
			</React.Fragment>
		);
	};

	// Return service card
	private getCarrierServicesList = (service: models.IService) => {
		return (
			<React.Fragment key={service.id}>
				<Divider />
				<ListItem ContainerComponent='div'>
					<ListItemText>
						<Grid container={true}>
							<Grid item={true} xs={8} sm={8} md={8} lg={8} xl={8}>
								<Grid container={true}>
									<Grid item={true} xs={6} sm={3} md={3} lg={3} xl={3}>
										<Typography noWrap={true} color='inherit' variant='body2'>
											<strong>{`${intlService.GetFormattedMessage('app.service-code-label')}:`}</strong>
										</Typography>
									</Grid>
									<Grid item={true} xs={6} sm={9} md={9} lg={9} xl={9}>
										<Typography variant='body2' noWrap={true}>
											{service.code}
										</Typography>
									</Grid>
								</Grid>
								<Grid container={true}>
									<Grid item={true} xs={6} sm={3} md={3} lg={3} xl={3}>
										<Typography noWrap={true} color='inherit' variant='body2'>
											<strong>{`${intlService.GetFormattedMessage('app.service-name-label')}:`}</strong>
										</Typography>
									</Grid>
									<Grid item={true} xs={6} sm={9} md={9} lg={9} xl={9}>
										<Typography noWrap={true} variant='body2'>
											{service.name}
										</Typography>
									</Grid>
								</Grid>
								<Grid container={true}>
									<Grid item={true} xs={6} sm={3} md={3} lg={3} xl={3}>
										<Typography noWrap={true} color='inherit' variant='body2'>
											<strong>{`${intlService.GetFormattedMessage('app.service-international-label')}: `}</strong>
										</Typography>
									</Grid>
									<Grid item={true} xs={6} sm={9} md={9} lg={9} xl={9}>
										<Typography noWrap={true} variant='body2'>
											{service.isInternational ? 'Yes' : 'No'}
										</Typography>
									</Grid>
								</Grid>
							</Grid>
							<Grid item={true} xs={2} sm={2} md={2} lg={2} xl={2} style={{ alignSelf: 'center' }}>
								<Link
									variant='body2'
									align='right'
									component='button'
									disabled={service.status === StatusEnum.Disabled}
									className={classNames({ 'disabled-link': service.status === StatusEnum.Disabled })}
									onClick={() => {
										const query = queryString.stringify({
											carrierCode: this.state.carrier.code,
											serviceCode: service.code,
										});

										const stateBreadcrumb = Array.isArray(this.props.history.location.state.breadcrumb)
											? this.props.history.location.state.breadcrumb
											: [this.props.history.location.state.breadcrumb];

										const breadcrumb = [
											...stateBreadcrumb,
											{ title: service.code, location: this.props.history.location },
										];

										this.props.history.push({
											pathname: this.props.match.url + '/service',
											search: query,
											state: {
												breadcrumb,
											},
										});
									}}
								>
									<FormattedMessage id='app.component.account-level-overrides' />
								</Link>
							</Grid>
							<Grid item={true} xs={2} sm={2} md={2} lg={2} xl={2}>
								<Typography variant='body2' align='right'>
									<Switch
										onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
											this.serviceID = service.id;
											this.serviceStatus = e.target.checked ? StatusEnum.Public : StatusEnum.Disabled;

											this.configCustomDialog(
												intlService.GetFormattedMessage('app.service-label'),
												intlService.GetFormattedMessage(
													e.target.checked
														? 'app.common.enable-confirm-dialog-text'
														: 'app.common.disable-confirm-dialog-text',
													{
														name: intlService.GetFormattedMessage('app.service-label'),
													}
												)
											);
										}}
										color='primary'
										disabled={false}
										checked={service.status === StatusEnum.Public ? true : false}
									/>
								</Typography>
							</Grid>
						</Grid>
					</ListItemText>
				</ListItem>
			</React.Fragment>
		);
	};

	private updateServiceStatus = async () => {
		try {
			const service = await adminCarrierService.updateService({
				id: this.serviceID,
				status: this.serviceStatus,
			});
			this.openSnackbar(intlService.GetFormattedMessage('app.snackbar.service-updated-successfully'));

			const index = this.state.services.findIndex((element) => element.id === service.id);
			const services = this.state.services;
			services[index].status = service.status;

			this.setState({ services });
		} catch (error) {
			throw error;
		}
	};

	private updateCarrierStatus = async () => {
		try {
			const result = await adminCarrierService.updateCarrier({
				id: this.state.carrier.id,
				status: this.state.carrierEnabled,
			});
			this.openSnackbar(intlService.GetFormattedMessage('app.snackbar.carrier-updated-successfully'));
			const carrier = this.state.carrier;
			carrier.status = result.status;
			this.setState({
				carrier,
				carrierEnabled: result.status,
			});
		} catch (error) {
			throw error;
		}
	};

	private updatePackageTypeStatus = async () => {
		try {
			const packageType = await adminCarrierService.updatePackageType({
				id: this.packageTypeID,
				status: this.packageTypeStatus,
			});
			this.openSnackbar(intlService.GetFormattedMessage('app.snackbar.package-type-updated-successfully'));

			const index = this.state.packageTypes.findIndex((element) => element.id === packageType.id);
			const packageTypes = this.state.packageTypes;
			packageTypes[index].status = packageType.status;

			this.setState({ packageTypes });
		} catch (error) {
			throw error;
		}
	};

	private updateSpecialServiceStatus = async () => {
		try {
			const specialService = await adminCarrierService.updateSpecialService({
				id: this.specialServiceID,
				status: this.specialServiceStatus,
			});
			this.openSnackbar(intlService.GetFormattedMessage('app.snackbar.special-service-updated-successfully'));

			const index = this.state.specialServices.findIndex((element) => element.id === specialService.id);
			const specialServices = this.state.specialServices;
			specialServices[index].status = specialService.status;

			this.setState({ specialServices });
		} catch (error) {
			throw error;
		}
	};
}

export default withRouter(withAxiosCancellation(withSnackBar(injectIntl(CarrierAdminDetailsComponent))));



// WEBPACK FOOTER //
// ./src/components/admin/carriers/admin-carrier-details.component.tsx